import marked from "marked";


/**
 *  @param { String } markdown - existing text
 *  @param { String } text - text to add
 *  @return { String } - new markdown
 */
const mergeMarkdown = (markdown,text) =>
  markdown ? markdown + text : text;

/**
 * Translates the markdown text into an array of results
 * @param { Markdown } text - markown to be translated
 * @return { Array } - array of objects
 *    One of:
 *      { type: "TEXT", text }
 *        @arg { Markdown } text - text in markdown; formatted
 *
 *      { type: "TABLE", headers, rows}
 *        @arg { Array } headers - array of headers
 *        @arg { Array } rows - array of rows
 */
const markdownToArray = text => {
  const tokens = marked.lexer(text);
  let results = [];
  let tempResult = {};

  const getParagraph = token => `${token.text}\n\n`;

  const getHeader = token => {
     let header = `# ${token.text}`;
     for (let j = 0; j < token.depth - 1; j++) {
       header = `#${header}`;
     }
     return `${header}\n`;
   };

  const addListToResults = (currentIndex) => {
    let listItemCounter = 0;
    const isOrderedList = tokens[currentIndex].ordered;
    let tempIndex = currentIndex;

    while (tokens[tempIndex].type !== "list_end") {
      tempIndex++;
      if (tokens[tempIndex].type === "text") {
        listItemCounter++;
        const listItem = isOrderedList ? `${listItemCounter}. ${tokens[tempIndex].text}\n` : `- ${tokens[tempIndex].text}\n`
        addTextToTempResults(listItem);
      }
    }

    results.push(tempResult);
    tempResult = {};
    return tempIndex;
  }

  const pushToResultsIfTempResultsNotEmpty = () => {
     if (!!tempResult && !!tempResult.text) {
       results.push(tempResult);
       tempResult = {};
     }
   }

  const pushToResultsOnLastToken = (currentIndex) => {
    if (currentIndex === tokens.length - 1) {
      results.push(tempResult);
    }
  }

  const addTextToTempResults = (text, currentIndex) => {
     tempResult = {
       type: "TEXT",
       text: mergeMarkdown(tempResult.text, text)
     };
     pushToResultsOnLastToken(currentIndex);
   }

   const addTableToResults = (token) => {
      tempResult = {
        type: "TABLE",
        headers: token.header,
        rows: token.cells
      };
      results.push(tempResult)
    }

  for (let i = 0; i < tokens.length; i++) {
    switch (tokens[i].type) {
      case "paragraph":
        const paragraph = getParagraph(tokens[i]);
        addTextToTempResults(paragraph, i);
        break;

      case "heading":
        const header = getHeader(tokens[i]);
        addTextToTempResults(header, i);
        break;

      case "list_start":
        pushToResultsIfTempResultsNotEmpty()

        // addListToResults moves the tokens index forward.
        // therefore i needs to be reassigned
        i = addListToResults(i);
        break;

      case "table":
        pushToResultsIfTempResultsNotEmpty();
        addTableToResults(tokens[i])
        break;

      case "code":
        let code = {};
        pushToResultsIfTempResultsNotEmpty();

        switch (tokens[i].lang) {
          case 'commands':
            code = {
              type: "COMMANDS",
              text: "```\n" + tokens[i].text + "\n```"
            }
            results.push(code);
            break;
          case 'plainJavascript':
            code = {
              type: "PLAIN_JAVASCRIPT",
              code: tokens[i].text
            }
            results.push(code);
            break;
          case 'plainJsx':
            code = {
              type: "PLAIN_JSX",
              code: tokens[i].text
            }
            results.push(code);
            break;
          case 'plainHtml':
            code = {
              type: "PLAIN_HTML",
              code: tokens[i].text
            }
            results.push(code);
            break;
          case 'plainCss':
            code = {
              type: "PLAIN_CSS",
              code: tokens[i].text
            }
            results.push(code);
            break;

          case "codeSandbox":
            code = {
              type: "CODE_SANDBOX",
              hash: tokens[i].text
            };
            results.push(code);
            break;

          case "react":
            code = {
              type: "REACT",
              reactCode: tokens[i].text
            };
            results.push(code);
            break;
          case "codepen":
            code = {
              type: "CODEPEN",
              hash: tokens[i].text
            };
            results.push(code);
            break;

          case "html":
            if (!!tokens[i + 1] && tokens[i + 1].lang === "css") {
              code = {
                type: "HTML_WITH_CSS",
                htmlCode: tokens[i].text,
                cssCode: tokens[i + 1].text
              };
              // jump over the css, b/c it has been just added
              i++;
            } else {
              code = {
                type: "HTML",
                htmlCode: tokens[i].text
              };
            }
            results.push(code);
            break;
          default:
            break;
        }

        break;

      default:
        break;
    }
  }
  // console.log(`results`, results);
  return results;
};

export default markdownToArray;



// WEBPACK FOOTER //
// ./src/utils/markdownToChapter.js